export enum Sector {
	State = 'state',
	StateReligious = 'state-religious',
	Arab = 'arab',
	UltraOrthodox = 'ultra-orthodox',
}